import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useCutiSettingListModel} from "@/stores/models/cuti-setting-list-model";

export const useCutiSettingListStore  = defineStore(
    'cutiSettingListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceCutiSettingList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useCutiSettingListModel().cutiSettingListCustomStore,
                filter: null,
            })
        );
       
        const loadData = async (filter = null) => {
            console.log("cutiSettingListStore loadData", filter);
            isLoading.value = true;
            try {
                dataSourceCutiSettingList.value.filter(filter);
                // Reload the DataSource with the new filter
                const result = await dataSourceCutiSettingList.value.load();
                return result;
            } catch (error) {
                console.error("Error loading data:", error);
                throw error;
            } finally {
                isLoading.value = false;
            }
        };

        const insertData = async (newItem) => {        
            try {
                console.log("cutiSettingListStore insertData 1", newItem);

                const result = await dataSourceCutiSettingList.value.store().insert(newItem);
                return result;
            } catch (error) {
                console.error("Error inserting data:", error);
                throw error;
            }
        };

        const updateData = async (updatedRows) => {

            const store = dataSourceCutiSettingList.value.store();
            try {
                // Create an array of update promises
                const updatePromises = updatedRows.map(row => {
                  return store.update(row.id, row); // Assume `id` is the key field
                });
          
                // Wait for all update operations to complete
               
                const results = await Promise.all(updatePromises);
          
                return results;
              } catch (error) {
                console.error("Error updating data:", error);
                throw error;
              }
        };


        



        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceCutiSettingList.value.reload();
        };

     

        const initialized = ()=>{     
              useCutiSettingListModel().setFilter(null); 
            dataSourceCutiSettingList.value.reload();
        };

        return {
           loadData,
           insertData,
           updateData,
            dataSourceCutiSettingList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);